import { Link, useLocation } from 'react-router-dom';

interface Crumb {
  label: string;
  to?: string;
}

const crumbMap: Record<string, Crumb[]> = {
  '/': [{ label: '首页' }],
  '/about': [
    { label: '首页', to: '/' },
    { label: '关于我们' },
  ],
};

function getBreadcrumbs(pathname: string): Crumb[] {
  if (crumbMap[pathname]) return crumbMap[pathname];

  if (pathname.startsWith('/category/')) {
    const slug = pathname.replace('/category/', '');
    return [
      { label: '首页', to: '/' },
      { label: '内容分类' },
    ];
  }

  if (pathname.startsWith('/article/')) {
    return [
      { label: '首页', to: '/' },
      { label: '内容分类', to: '/category/entertainment' },
      { label: '文章详情' },
    ];
  }

  return [{ label: '首页', to: '/' }];
}

export default function Breadcrumb() {
  const location = useLocation();
  const crumbs = getBreadcrumbs(location.pathname);

  if (crumbs.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="pt-20 pb-0">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <ol className="flex items-center gap-2 text-xs text-foreground-500 py-3 flex-wrap">
          {crumbs.map((crumb, index) => (
            <li key={index} className="flex items-center gap-2">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              )}
              {crumb.to ? (
                <Link
                  to={crumb.to}
                  className="hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-foreground-700 font-medium whitespace-nowrap">
                  {crumb.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}